<template>
  <div class="mt-2">
    <div
      class="ces-area mb-4"
      v-if="justView || addQuestionTemplate === 'default'"
    >
      <div
        class="question-area"
        :style="{
          color: textColor || '#000000',
        }"
      >
       <span :class="`${this.$route.fullPath.includes('treatments') ? 'text-addquestion' : ''}`"> {{ text }} </span>
      </div>
      <div
        v-if="justView"
        class="grade-area"
        style="display: flex; justify-content: center;"
      >
        <span v-for="(button, i) in buttons" :style="handleStyle(i)" :key="i">
          {{ button.value }}
        </span>

        <applicable
          style="margin-top: -10px;"
          v-if="reviewAnswer === -1"
          :justView="justView"
          :itemId="index"
        />
      </div>
      <div v-else>
        <div>
          <div class="grade-area">
            <button
              v-for="(button, i) in buttons"
              @click="handleClick(button.value, i)"
              @mouseover="handleHover($event.target, i, true)"
              @mouseleave="handleHover($event.target, i, false)"
              :style="handleStyle(i)"
              :key="i"
            >
              {{ button.value }}
            </button>
          </div>
          <applicable
            class="applicable-btn"
            v-if="applicableEnabled"
            :itemId="index"
            v-model="applicabled"
            :selectedButton="selectedButton"
            @click.native="selectedButton = !selectedButton"
            :lang="lang"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="ces-area-big mb-4">
        <div
          class="question-area"
          :style="{
            color: textColor || '#000000',
          }"
        >
          {{ text }}
        </div>
        <div>
          <div>
            <div class="grade-area">
              <button
                v-for="(button, i) in buttons"
                @click="handleClick(button.value, i)"
                @mouseover="handleHover($event.target, i, true)"
                @mouseleave="handleHover($event.target, i, false)"
                :style="handleStyle(i)"
                :key="i"
              >
                {{ button.value }}
              </button>
            </div>
            <applicable
              class="applicable-big"
              v-if="applicableEnabled"
              :itemId="index"
              v-model="applicabled"
              :selectedButton="selectedButton"
              @click.native="selectedButton = !selectedButton"
              :lang="lang"
            />
          </div>
        </div>
      </div>
    </div>

    <comment-area
      :clickButton="expandComment"
      :template="addQuestionTemplate"
      v-if="commentEnabled && !justView"
      v-model="comment"
    />

    <p
      v-if="hasComment && justView"
      class="comment-area"
      :style="{
        color: textColor || '#000000',
      }"
    >
      Comentário: {{ hasComment }}
    </p>

    <hr />
  </div>
</template>

<script>
import commentArea from '../comment-area';
import applicable from '../applicable';

export default {
  name: 'cesScale',

  components: {
    commentArea,
    applicable,
  },

  data: () => ({
    items: 11,
    position: null,
    buttons: [
      { value: 1, selected: false, color: '#d62027' },
      { value: 2, selected: false, color: '#faa823' },
      { value: 3, selected: false, color: '#e8e73d' },
      { value: 4, selected: false, color: '#c5d92d' },
      { value: 5, selected: false, color: '#64b64d' },
    ],
    gradeSelected: null,
    comment: null,
    applicabled: null,
    selectedButton: false,
    expandComment: false,
  }),

  props: {
    text: { type: String, required: true },
    textColor: { type: String, required: false },
    itemId: { type: String, required: true },
    index: { type: Number, required: true },
    justView: { type: Boolean, default: false },
    selected: { type: Number },
    colorTemplate: { type: String, required: false, default: 'colors' },
    commentEnabled: { type: Boolean, default: false },
    applicableEnabled: { type: Boolean, default: false },
    hasComment: { type: String, default: null },
    reviewAnswer: { type: Number, required: false },
    addQuestionTemplate: { type: String, required: true, default: 'default' },
    idQuestion: { type: String, required: true },
    lang: { type: String, default: 'br' }
  },

  watch: {
    comment: function watchComment() {
      this.update();
    },
    applicabled: function watchApplicated(value) {
      this.$emit('input', {
        review: value,
      });
    },
    selectedButton: function watchSelectedButton(value) {
      if (value) {
        this.selectedButton = true;
        this.buttons.forEach((el) => {
          el.selected = false;
        });

        this.$emit('input', {
          review: -1,
          comment: this.comment,
        });
      } else {
        this.gradeSelected = value;
      }
    },
    gradeSelected: function watchGradeSelected(value) {
      this.gradeSelected = value;
    },
  },

  methods: {
    handleClick(value, i) {
      this.expandComment = true;

      this.buttons.forEach((el) => {
        el.selected = false;
      });

      if (value !== this.gradeSelected) {
        this.buttons[i].selected = true;
        this.gradeSelected = value;
      } else {
        this.expandComment = false;
        this.gradeSelected = null;
      }

      this.update();
    },

    handleStyle(i) {
      const style = { borderColor: '#bdbdbd', color: '#bdbdbd' };

      if (this.colorTemplate !== 'grades') {
        style.borderColor = this.buttons[i].color;
        style.color = this.buttons[i].color;
      }

      if (this.buttons[i].selected) {
        style.background = this.buttons[i].color;
        style.color = '#fff';
      }

      return style;
    },

    handleHover(element, i, active) {
      if (active) {
        element.style.backgroundColor = this.buttons[i].color;
        element.style.color = '#fff';
      } else if (!this.buttons[i].selected) {
        if (this.colorTemplate === 'colors') {
          element.style.backgroundColor = '#fff';
          element.style.color = this.buttons[i].color;
          element.style.borderColor = this.buttons[i].color;
        } else {
          element.style.backgroundColor = '#fff';
          element.style.color = '#bdbdbd';
        }
      }
    },

    update() {
      this.selectedButton = false;

      this.$emit('input', {
        review: this.gradeSelected,
        comment: this.comment,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
  },

  mounted() {
    if (this.selected >= 0) {
      this.buttons.forEach((el) => {
        if (el.value === this.selected) {
          el.selected = true;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.applicable-big {
  margin-top: -50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 65%;
}

.ces-area {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .grade-area {
    display: flex;
    flex-direction: row;

    button {
      border: 1px solid $gray;
      border-radius: 4px;
      color: $gray;
      padding: 4px;
      background: transparent;
      min-width: 30px;
      max-height: 38px;
      margin-top: 10px;
      outline: 0;
    }

    span {
      text-align: center;
      border: 1px solid $gray;
      border-radius: 4px;
      color: $gray;
      padding: 4px;
      background: transparent;
      min-width: 30px;
      outline: 0;
    }
  }
}

.ces-area-big {
  //display: flex;
  align-items: center;
  justify-content: center;

  .question-area {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .grade-area {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      border: 1px solid $gray;
      border-radius: 4px;
      color: $gray;
      padding: 4px;
      background: transparent;
      min-width: 54px;
      max-height: 48px;
      min-height: 48px;
      margin-top: 10px;
      outline: 0;
    }

    span {
      text-align: center;
      border: 1px solid $gray;
      border-radius: 4px;
      color: $gray;
      padding: 4px;
      background: transparent;
      min-width: 30px;
      outline: 0;
    }
  }
}

.comment-area {
  font-style: italic;
}

.applicable-btn {
  float: right;
}

@media only screen and (max-width: 1200px) {
  .applicable-big {
    margin-top: 0px;
  }

  .ces-area-big {
    align-items: center;
    justify-content: center;

    .question-area {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .grade-area {
      display: flex;
      align-items: center;
      justify-content: center;

      button {
        border: 1px solid $gray;
        border-radius: 4px;
        color: $gray;
        padding: 4px;
        background: transparent;
        min-width: 9%;
        max-height: 40px;
        min-height: 40px;
        margin-top: 10px;
        outline: 0;
      }

      span {
        text-align: center;
        border: 1px solid $gray;
        border-radius: 4px;
        color: $gray;
        padding: 4px;
        background: transparent;
        min-width: 30px;
        outline: 0;
      }
    }
  }

  .ces-area {
    flex-direction: column;

    .grade-area {
      margin-top: 16px;

      button {
        padding: 6px;
        min-width: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/ces/index.vue